import { render } from "./ReportTable.vue?vue&type=template&id=2c2b449d&ts=true"
import script from "./ReportTable.vue?vue&type=script&lang=ts"
export * from "./ReportTable.vue?vue&type=script&lang=ts"

import "./report-table.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__